import { MapsWidget } from '@/components/MapsWidget';
export const frontmatter = {
  category: 'guia',
  title: 'Où se situe l\'Ilha do Mel : statut, carte et comment s\'y rendre (2026)',
  excerpt: 'L\'île de Mel se trouve dans l\'État du Paraná, et non dans l\'État de Santa Catarina. Découvrez sa situation géographique exacte, la distance qui la sépare de Curitiba, comment s\'y rendre en voiture et en bus, et consultez une carte de l\'île.',
  publishedAt: '2026-04-25',
  author: 'Guia Ilha do Mel',
  tags: ['localizacao', 'como-chegar', 'parana', 'mapa', 'curitiba'],
  coverImage: '/images/hero-bg.jpg',
  readingTime: '5 min',
};

Où se situe l'Ilha do Mel : État, carte et comment s'y rendre

Si vous cherchez « Où se trouve Ilha do Mel ? », « Ilha do Mel Paraná » ou encore « Ilha do Mel SC », ce guide répond à toutes vos questions. Ilha do Mel est l'une des destinations les mieux préservées de la côte brésilienne et se situe dans l'État du Paraná, au sud du Brésil.

---

Dans quel État se situe Ilha do Mel ?

L'Ilha do Mel (Île de Miel) est située sur la **côte du Paraná**, plus précisément dans la **baie de Paranaguá**, à environ 100 km au sud de la capitale Curitiba. C'est une île sans voitures, sans routes goudronnées et avec des infrastructures limitées, ce qui en fait un refuge naturel unique au Brésil.

Coordonnées géographiques : 25°32′S 48°20′O

---

Est-Ilha do Mel à Santa Catarina?

**Non.** Contrairement à une idée reçue (surtout pour les habitants de Santa Catarina), l'Ilha do Mel fait **entièrement** partie de l'État du Paraná. La confusion vient du fait que :

L'île se situe à la frontière géographique entre les États du Paraná et de Santa Catarina.

De nombreux touristes de Florianópolis et de Balneário Camboriú visitent l'île.

On y accède par les villes proches de la frontière.

Mais officiellement, Ilha do Mel appartient à la municipalité de **Paranaguá**, au Paraná.

---

Distance entre Curitiba et Ilha do Mel

La distance entre **Curitiba et Ilha do Mel** est d'environ :

- **En voiture :** 110 km jusqu'à Pontal do Sul (1 h 40) + 30 min en bateau

- **En bus :** 1 h 30 jusqu'à Paranaguá + 30 min en bateau

- **Durée totale du trajet :** environ 2 h 30 à 3 h depuis Curitiba

Le trajet en voiture suit la BR-277 (Rodovia do Café) jusqu'à Paranaguá, puis continue jusqu'à Pontal do Sul ou Paranaguá, où vous montez à bord du bateau.

[Voir le guide complet sur comment s'y rendre →](/blog/como-chegar)

---

Plan de Ilha do Mel (Île de Miel)

L'île mesure environ **25 km de long** et est divisée en deux villages principaux :

| Village | Caractéristiques | Accès |

| ----------------- | --------------------------------------------------- | ------------------------- |

| **Nova Brasilia** | Plus grandes infrastructures, restaurants, plages de Farol | Jetée de Nova Brasilia |

| **Encantadas** | Plus tranquille, lever du soleil, accès aux sentiers | Jetée Encantadas |

La partie nord de l'île abrite la **Forteresse de Notre-Dame des Plaisirs** et la **Plage de la Forteresse**, une plage pratiquement déserte de 4 km de long.

---

Villes voisines

| Ville | Distance | Temps de conduite |

| ------------- | --------- | ---------- |

| Curitiba | 110km | 1h40 |

| Paranaguá | 25km | 30 minutes |

| Pontal do Sul | 30km | 35 minutes |

| Guaratuba | 60km | 1h |

| Morretes | 40km | 50 minutes |

---

Comment s'y rendre : résumé rapide

1. **Arrivée à Pontal do Sul ou Paranaguá** en voiture ou en bus.

2. **Garage** (30-50 R$/jour à Pontal do Sul).

3. **Embarquement** (35-50 R$ l'aller simple, traversée de 30 à 40 minutes).

4. **Débarquement** à Nova Brasília ou Encantadas.

**Conseil important :** Il est impossible d’amener une voiture sur l’île. La traversée se fait uniquement par bateau ou ferry, et sur l’île, les déplacements se font à pied ou en charrette à bras.

[Guide complet pour s'y rendre avec les prix mis à jour →](/blog/como-chegar)

---

Pourquoi visiter Ilha do Mel ?

Ilha do Mel est un **parc d'État** et une zone de protection environnementale. Sans voitures, sans distributeurs automatiques et avec des infrastructures limitées, l'île offre :

- **9 plages** aux eaux cristallines

- **6 sentiers** à travers la forêt atlantique

- **Forteresse historique** du XVIIIe siècle

- **Excursions en bateau** avec plongée en apnée

- **Cuisine maison** à base de fruits de mer

[Voir le guide complet de l'Ilha do Mel →](/guide-complete)